import React from 'react';
import Select from 'react-select';
import {
    Switch,
    Link,
    Route,
    Redirect
} from 'react-router-dom';
import classNames from 'classnames';
import { Link as ScrollLink } from 'react-scroll';
import { DropdownButton, SplitButton, MenuItem, Modal } from 'react-bootstrap';

import Account from '../_global/Account.jsx';
import Footer from '../_global/Footer.jsx';
import Usage from '../projects/Usage.jsx';
import Setup from '../projects/Setup.jsx';
import Comments from '../projects/Comments.jsx';

import api from '../../utils/api';

import logo from '../../assets/img/logo.svg';
import '../../styles/layouts/MainLayout.css';


class MainLayout extends React.Component {

    apiCall = null;

    ref = React.createRef();

    state = {
        acceptedModeratorRequests: null,
        pendingModeratorRequests: null,
        moderatorRequestOptions: {},
        stripeCustomer: null,
        projects: null,
        subcategory: null,
        subcategoryTitles: [],
        underFold: false,
        sentEmailVerification: false,
        showAccount: false
    };

    componentDidMount() {

        this.getStripeCustomer()
            .then(() => this.getModeratorRequests())
            .then(() => this.getProjects());

        window.addEventListener('scroll', this.onScroll);
    }

    componentWillUnmount() {

        api.cancel(this.apiCall);
        window.removeEventListener('scroll', this.onScroll);
    }

    renderValue = project => {
        return <h3 className="selected-project">{project.name}{project.userId !== this.props.user.uid ? (<span className="label label-default">mod</span>) : null}</h3>;
    };

    changeStripeCustomer = (stripeCustomer, callback) => {

        this.setState({ stripeCustomer }, callback);
    };

    onScroll = () => {

        if (window.scrollY > this.ref.current.offsetTop) {

            if (!this.state.underFold) {
                this.setState({
                    underFold: true
                });
            }

        } else {

            if (this.state.underFold) {
                this.setState({
                    underFold: false
                });
            }
        }
    };

    onChangeSubcategoryFromButton = ({ currentTarget: { value: subcategory } }) => {

        this.onChangeSubcategory(subcategory);
    };

    onChangeSubcategory = subcategory => {

        this.setState({ subcategory });
    };

    onChangeSubcategoryTitles = subcategoryTitles => {

        this.setState({ subcategoryTitles });
    };

    onToggleAccount = e => {

        this.setState({ showAccount: !this.state.showAccount });
    };

    scrollTo = (to, body) => {

        return (
            <ScrollLink
                className="menu-item"
                to={to}
                smooth={true}
                offset={-40}
                duration={200}
                onSetActive={this.onChangeSubcategory}
                spy={true}
            >
                {body || <span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/>}
            </ScrollLink>
        );
    };

    getStripeCustomer = () => {

        return new Promise(resolve => {

            this.apiCall = api.getStripeCustomer().then(({ data: stripeCustomer }) => {

                this.setState({ stripeCustomer }, resolve);
            });
        });
    };

    getModeratorRequests = (accumulated = [], cursor = null) => {

        return new Promise(resolve => {

            this.apiCall = api.getModeratorRequests({ cursor }).then(({ data: { requests, info } }) => {

                const allRequests = accumulated.concat(requests);

                if (info.moreResults === 'NO_MORE_RESULTS') {

                    const moderatorRequestOptions = {};
                    const acceptedModeratorRequests = [];
                    const pendingModeratorRequests = [];

                    allRequests.forEach(request => {

                        if (!request.status) {
                            moderatorRequestOptions[`${request.projectId}/reject/block`] = false;
                            moderatorRequestOptions[`${request.projectId}/accept/notifyApproved`] = true;
                            moderatorRequestOptions[`${request.projectId}/accept/notifyPending`] = true;
                            moderatorRequestOptions[`${request.projectId}/accept/notifyFlagged`] = true;
                            return pendingModeratorRequests.push(request);
                        }
                        moderatorRequestOptions[`${request.projectId}/accept/notifyApproved`] = !!request.notifyApproved;
                        moderatorRequestOptions[`${request.projectId}/accept/notifyPending`] = !!request.notifyPending;
                        moderatorRequestOptions[`${request.projectId}/accept/notifyFlagged`] = !!request.notifyFlagged;

                        return acceptedModeratorRequests.push(request);
                    });

                    return this.setState({
                        acceptedModeratorRequests,
                        pendingModeratorRequests,
                        moderatorRequestOptions
                    }, resolve);

                }

                return this.getModeratorRequests(allRequests, info.endCursor).then(resolve);
            });

        });
    };

    getProjects = (accumulated = [], cursor = null) => {

        return new Promise(resolve => {

            this.apiCall = api.getProjects({ cursor }).then(({ data: { projects, info } }) => {

                const allProjects = accumulated.concat(projects);

                if (info.moreResults === 'NO_MORE_RESULTS') {

                    return this.setState({ projects: allProjects }, resolve);
                }

                return this.getProjects(allProjects, info.endCursor).then(resolve);
            });

        });
    };

    changeProjects = changeFn => {

        return new Promise((resolve, reject) => {

            if (!this.state.projects) {
                return reject(new Error('No projects loaded yet.'));
            }
            this.setState({
                projects: changeFn(this.state.projects)
            }, () => {
                resolve();
            });
        });
    };

    onChangeModeratorRequestOptions = ({ currentTarget: { value, checked } }) => {

        this.changeModeratorRequestOptions({ [value]: checked });
    };

    changeModeratorRequestOptions = (state, callback) => {

        this.setState({
            moderatorRequestOptions: Object.assign({}, this.state.moderatorRequestOptions, state)
        }, callback);
    };

    onAcceptRequest = ({ currentTarget: { value: projectId } }) => {

        this.acceptRequest(projectId);
    };

    acceptRequest = projectId => {

        this.props.changeCover(true, () => {

            const notifyApproved = !!this.state.moderatorRequestOptions[`${projectId}/accept/notifyApproved`];
            const notifyPending = !!this.state.moderatorRequestOptions[`${projectId}/accept/notifyPending`];
            const notifyFlagged = !!this.state.moderatorRequestOptions[`${projectId}/accept/notifyFlagged`];

            this.apiCall = api.acceptModeratorRequest({
                projectId,
                notifyApproved,
                notifyPending,
                notifyFlagged
            })
                .then(() => this.getProjects())
                .then(() => {

                    this.setState(state => {

                        return {
                            pendingModeratorRequests: state.pendingModeratorRequests.filter(request => request.projectId !== projectId)
                        };
                    }, () => {
                        this.props.changeCover(false);
                    })
                });
        });
    };

    onRejectRequest = ({ currentTarget: { value: projectId } }) => {

        this.props.changeCover(true, () => {

            const block = !!this.state.moderatorRequestOptions[`${projectId}/reject/block`];

            this.apiCall = api.rejectModeratorRequest({
                projectId,
                block
            })
                .then(() => this.getProjects())
                .then(() => {

                this.setState(state => {

                    return {
                        pendingModeratorRequests: state.pendingModeratorRequests.filter(request => request.projectId !== projectId)
                    };
                }, () => {
                    this.props.changeCover(false);
                })
            });
        });
    };


    onChangeProject = selectedProjectId => {

        const { history } = this.props;

        if (selectedProjectId) {

            return history.push(`/projects/${selectedProjectId}/comments`);
        }

        history.push('/projects');
    };

    onSendEmailVerification = () => {

        this.props.changeCover(true, () => {

            this.props.user.sendEmailVerification({
                url: window.location.href
            })
                .then(() => {

                    this.setState({ sentEmailVerification: true });
                })
                .catch(err => {

                    this.setState({ sentEmailVerification: false });
                })
                .then(() => {

                    this.props.changeCover();
                });
        });
    };


    goToProjectSetup = projectId => {

        this.props.history.push(`/projects/${projectId}`);
    };

    SetupHOC = props => {

        const {
            match: {
                params: { id }
            }
        } = this.props;

        let project = id ? this.state.projects.find(project => project.id === id) : null;

        if (id && !project) {

            return (
                <Redirect to="/projects" />
            );
        }

        const notificationSettings = {
            notifyApproved: !!this.state.moderatorRequestOptions[`${id}/accept/notifyApproved`],
            notifyPending: !!this.state.moderatorRequestOptions[`${id}/accept/notifyPending`],
            notifyFlagged: !!this.state.moderatorRequestOptions[`${id}/accept/notifyFlagged`]
        };

        return (
            <Setup
                {...props}
                key={id}
                project={project || {}}
                notificationSettings={notificationSettings}
                {...this.passingProps}
            />
        );
    };

    CommentsHOC = props => {

        const {
            match: {
                params: { id }
            }
        } = this.props;

        let project = id ? this.state.projects.find(project => project.id === id) : null;

        if (!project) {

            return (
                <Redirect to="/projects" />
            );
        }

        return (
            <Comments
                {...props}
                key={`${id}/${this.state.subcategory}`}
                project={project}
                {...this.passingProps}
            />
        );

    };

    get passingProps() {

        return {
            user: this.props.user,
            stripeCustomer: this.state.stripeCustomer,
            changeStripeCustomer: this.changeStripeCustomer,
            togglePaymentMethodModal: this.props.togglePaymentMethodModal,
            changeCover: this.props.changeCover,
            changeUserDisplayName:this.props.changeUserDisplayName,
            changeUserEmail:this.props.changeUserEmail,
            requestPasswordReset:this.props.requestPasswordReset,
            deleteAccount:this.props.deleteAccount,
            logout: this.props.logout,
            projects: this.state.projects,
            subcategory: this.state.subcategory,
            changeProjects:this.changeProjects,
            goToProjectSetup: this.goToProjectSetup,
            onChangeSubcategory: this.onChangeSubcategory,
            onChangeSubcategoryTitles: this.onChangeSubcategoryTitles,
            changeModeratorRequestOptions: this.changeModeratorRequestOptions,
            onRejectRequest: this.onRejectRequest,
            acceptRequest: this.acceptRequest,
            scrollTo: this.scrollTo
        };
    }

    get setupSubcategories() {

        return this.state.subcategoryTitles.map(({ id, title }) => (
            <li key={id} className={classNames({ active: this.state.subcategory === id })}>
                {this.scrollTo(id, title)}
            </li>
        ));
    }

    get commentsSubcategories() {

        return this.state.subcategoryTitles.map(({ id, title }) => (
            <li key={id} className={classNames({ active: this.state.subcategory === id })}>
                <button
                    className="menu-item"
                    value={id}
                    onClick={this.onChangeSubcategoryFromButton}
                >
                    {title}
                </button>
            </li>
        ));
    }

    get alert() {

        if (this.props.user.emailVerified) {
            return null;
        }

        return (
            <div className="alert alert-warning" role="alert">
                <p>
                    Before saving any projects or accepting moderator requests, you'll have to confirm your email address by opening the link we sent to <strong>{this.props.user.email}</strong>.
                </p>
                <p>
                    Didn't get an email? <button className="btn btn-link" onClick={this.onSendEmailVerification}>Click here</button> to send another.
                </p>
            </div>
        );
    }

    get tab () {

        return this.state.projects ? (
            <Switch>

                <Route path="/projects/:id/comments" component={this.CommentsHOC} />

                <Route path="/projects/:id?" component={this.SetupHOC} />

            </Switch>
        ) : null;
    }

    get pendingModeratorRequests() {

        if (!this.state.pendingModeratorRequests) {
            return null;
        }

        return this.state.pendingModeratorRequests.map(request => (
            <li className="list-group-item" key={request.projectId}>

                <div className="media">
                    <div className="media-left">
                        <a target="_blank" href={`mailto:${request.requestedBy.email}`}>
                            <img className="media-object" src={request.requestedBy.photoURL} alt={request.requestedBy.displayName}/>
                        </a>
                    </div>
                    <div className="media-body">
                        <p>
                            {request.requestedBy.displayName} (<a target="_blank" href={`mailto:${request.requestedBy.email}`}>{request.requestedBy.email}</a>) has invited you to be a moderator for "{request.projectName}".
                        </p>

                    </div>
                </div>


                <div className="row">

                    <div className="col-xs-6" style={{textAlign: 'right'}}>

                        <div className="options">

                            <SplitButton
                                bsStyle="danger"
                                title="Reject"
                                id={`reject-${request.projectId}`}
                                value={request.projectId}
                                onClick={this.onRejectRequest}
                                pullRight
                            >
                                <div className="checkbox">
                                    <label>
                                        <input
                                            type="checkbox"
                                            value={`${request.projectId}/reject/block`}
                                            checked={!!this.state.moderatorRequestOptions[`${request.projectId}/reject/block`]}
                                            onChange={this.onChangeModeratorRequestOptions}
                                        />
                                        Block future requests from "{request.projectName}"
                                    </label>
                                </div>
                            </SplitButton>

                        </div>

                    </div>

                    <div className="col-xs-6">

                        <div className="options">

                            <SplitButton
                                bsStyle="info"
                                title="Accept"
                                id={`accept-${request.projectId}`}
                                value={request.projectId}
                                onClick={this.onAcceptRequest}
                            >
                                <div className="checkbox">
                                    <label>
                                        <input
                                            type="checkbox"
                                            value={`${request.projectId}/accept/notifyApproved`}
                                            checked={!!this.state.moderatorRequestOptions[`${request.projectId}/accept/notifyApproved`]}
                                            onChange={this.onChangeModeratorRequestOptions}
                                        />
                                        Notify me of new automatically approved comments
                                    </label>
                                </div>
                                <div className="checkbox">
                                    <label>
                                        <input
                                            type="checkbox"
                                            value={`${request.projectId}/accept/notifyPending`}
                                            checked={!!this.state.moderatorRequestOptions[`${request.projectId}/accept/notifyPending`]}
                                            onChange={this.onChangeModeratorRequestOptions}
                                        />
                                        Notify me of new comments pending moderation
                                    </label>
                                </div>
                                <div className="checkbox">
                                    <label>
                                        <input
                                            type="checkbox"
                                            value={`${request.projectId}/accept/notifyFlagged`}
                                            checked={!!this.state.moderatorRequestOptions[`${request.projectId}/accept/notifyFlagged`]}
                                            onChange={this.onChangeModeratorRequestOptions}
                                        />
                                        Notify me of flagged comments
                                    </label>
                                </div>
                            </SplitButton>

                        </div>

                    </div>

                </div>

            </li>
        ));
    }

    render() {

        const {
            user,
            match: {
                params: { id, section }
            }
        } = this.props;

        const baseUrl = id ? `/projects/${id}` : '/projects';

        if (!user) {

            return (
                <Redirect to="/login" />
            );
        }

        if (!this.state.stripeCustomer) {
            return (
                <div className="disabled-cover">
                    <div className="loader">Loading...</div>
                </div>
            );
        }

        const project = id ? (this.state.projects || []).find(project => project.id === id) : null;


        return (
            <div className="layout main-layout">

                <div className="layout-content">

                    <header className="container-fluid alt-bg">
                        <nav className="navbar">
                            <div className="navbar-header">
                                <Link className="navbar-brand" to="/"><img src={logo} alt="CommentBox" /></Link>
                            </div>

                            <div className="navbar-right">

                                <ul className="nav navbar-nav">
                                    <li><a target="_blank" href="https://commentbox.io">Home</a></li>
                                    <li><a target="_blank" href="https://commentbox.io/blog">Blog</a></li>
                                    <li><a target="_blank" href="https://commentbox.io/docs">Docs</a></li>
                                </ul>

                                <DropdownButton id="projects" title={user.displayName} pullRight>
                                    <MenuItem onSelect={this.onToggleAccount}>Account</MenuItem>
                                    <MenuItem divider />
                                    <MenuItem onSelect={this.props.logout}>Logout</MenuItem>
                                </DropdownButton>
                            </div>
                        </nav>
                    </header>

                    <Account
                        show={this.state.showAccount}
                        hide={this.onToggleAccount}
                        {...this.passingProps}
                    />

                    <Modal show={this.props.user.emailVerified && this.state.pendingModeratorRequests && this.state.pendingModeratorRequests.length > 0}>

                        <Modal.Header>
                            <Modal.Title>Moderator Requests</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>

                            <ul className="list-group moderator-requests">
                                {this.pendingModeratorRequests}
                            </ul>
                        </Modal.Body>
                    </Modal>

                    <div className="container-fluid search-container">

                        <div className="row">

                            <div className="col-lg-4 col-lg-offset-8 col-md-4 col-md-offset-8 col-sm-6 col-sm-offset-6 col-xs-12">

                                <div className="project-selector">
                                    <Select
                                        name="form-field-name"
                                        value={id || null}
                                        onChange={this.onChangeProject}
                                        options={this.state.projects || []}
                                        isLoading={!this.state.projects}
                                        valueKey="id"
                                        labelKey="name"
                                        placeholder={<h3 className="selected-project placeholder">Create new project</h3>}
                                        simpleValue={true}
                                        optionRenderer={this.renderValue}
                                        valueRenderer={this.renderValue}
                                        noResultsText={<h3 className="selected-project placeholder">No projects found</h3>}
                                    />
                                </div>

                            </div>
                        </div>

                    </div>


                    <div className={classNames('content', { 'under-fold': this.state.underFold })} ref={this.ref}>

                        <div className="sidebar-container">

                            <div className="sidebar">

                                <ul className="nav nav-sidebar">

                                    <li role="presentation" className={classNames({ active: !section })}>
                                        <Link className="menu-item" to={baseUrl}>Setup</Link>
                                        <ul className="nav">
                                            {!section ? this.setupSubcategories : null}
                                        </ul>
                                    </li>

                                    <li role="presentation" className={classNames({ active: section === 'comments', disabled: !id })}>
                                        {
                                            id ? (
                                                <Link className="menu-item" to={`${baseUrl}/comments`}>Comments</Link>
                                            ) : <a className="menu-item">Comments</a>
                                        }
                                        <ul className="nav">
                                            {section === 'comments' ? this.commentsSubcategories : null}
                                        </ul>
                                    </li>

                                </ul>

                            </div>

                            <div className="container">

                                <div className="row">

                                    <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-2 col-sm-8 col-sm-offset-4">

                                        {this.alert}

                                        <div className="tab">

                                            {this.tab}

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div className="push" />
                </div>

                <Footer />

            </div>
        );
    }
}

export default MainLayout;


// WEBPACK FOOTER //
// ./src/components/layouts/MainLayout.jsx